import './EventList.scss';
import { bool2str, componentId, forAll } from '@stst/Javascript/util';

/**
 * @param {MouseEvent} e
 */
const toggleEventListItem = e => {
    /** @type {HTMLButtonElement} */
    const button = e.currentTarget;
    const element = button.closest('.event-list-item');
    const shouldBeExpanded = button.getAttribute('aria-expanded') !== 'true';
    button.setAttribute('aria-expanded', bool2str(shouldBeExpanded));
    const p = element.querySelector('.event-list-item__text');
    p.setAttribute('aria-hidden', bool2str(!shouldBeExpanded));
    if (shouldBeExpanded) {
        element.classList.add('event-list-item--expanded');
    } else {
        element.classList.remove('event-list-item--expanded');
    }
};

const setupEventListItem = element => {
    const p = element.querySelector('.event-list-item__text');
    if (!p) {
        return;
    }
    const button = document.createElement('BUTTON');
    button.classList.add('event-list-item__button');
    button.setAttribute('aria-expanded', 'false');
    const h3 = element.querySelector('h3');
    Array.from(h3.childNodes).forEach(e => button.appendChild(e));
    h3.appendChild(button);
    button.addEventListener('click', toggleEventListItem);
    const elId = 'event-list-item__' + componentId();
    button.setAttribute('aria-controls', elId);
    p.setAttribute('id', elId);
    p.setAttribute('aria-hidden', 'true');
};

forAll('.event-list-item', setupEventListItem);
